/**
 * Created by kb on 2017/09/18.
 */

export  const  reqUrlConf= {
  ht:{
    queryContractList:'/con/contract/queryContractList',//合同列表
    getContract:'/con/contract/getContract',//合同详情
    getMessage:'/con/contract/getMessage',//获取子数据
    updateContract:'/con/contract/updateContract', //修改合同
    addContract:'/con/contract/addContract', //新增合同
    updateApproveStatus:'/con/contract/updateApproveStatus',//修改状态
    getContractDetailPro:'/con/contract/getContractDetailPro',
    queryContractcCustomerList:'/con/contract/queryContractcCustomerList',//合同列表
    getContractPriceList:'/con/contract/getContractPriceList', //合同价表
    //合同变更
    queryContractChangeList:'/con/contractChange/queryContractChangeList',
    getContractChange:'/con/contractChange/getContractChange',
    addContractChange:'/con/contractChange/addContractChange',
    updateContractChange:'/con/contractChange/updateContractChange',
    updateChangeApproveStatus:'/con/contractChange/updateChangeApproveStatus',
    countHavingGift: '/con/contract/countHavingGift',
    deleteProByProductIdAndId:'/con/contract/deleteProByProductIdAndId',

    // 合同返利规则
    queryContractRebateVOs:'/con/rebate/queryContractRebateVOs',
    queryProductsByRebate:'/con/rebate/queryProductsByRebate',
    queryContractsByRebate:'/con/rebate/queryContractsByRebate',
    
    //返利
    queryConContractRebateRate:"/con/conContractRebateRate/queryConContractRebateRate",  // 分页
    addConContractRebateRate:"/con/conContractRebateRate/addConContractRebateRate",  // 添加
    updateConContractRebateRate:"/con/conContractRebateRate/updateConContractRebateRate",  // 更新
    removeConContractRebateRate:"/con/conContractRebateRate/removeConContractRebateRate",  // 删除
    getConContractRebateRate:'/con/conContractRebateRate/getConContractRebateRate',  //详情
    
    queryExpireContractList:'/con/contract/queryExpireContractList',//失效合同列表
    batchUpdateApproveStatus:'/con/contract/batchUpdateApproveStatus',
  
  },
  //商品
  product:{
    addProductCategory: '/bd/productcategory/addProductCategory', // 新增商品类型
    updateProductCategory: '/bd/productcategory/updateProductCategory', // 修改商品类型
    queryProductCategoryList: '/bd/productcategory/queryProductCategoryList', // 商品类型列表
    getProductCategory:'/bd/productcategory/getProductCategory',//详情
    deleteProductCategory:'/bd/productcategory/deleteProductCategory', //删除

    queryProductNumList:'/bd/product/queryProductNumList', // 商品库存列表
    queryProductListPost:'/bd/product/queryProductListPost', // 商品库存列表
    queryProductList:'/bd/product/queryProductList',//商品列表
    queryProducts:'/bd/product/queryProducts',//订单引用商品列表
    queryProductsByAddOrder:'/bd/product/queryProductsByAddOrder',//新增订单引用商品列表
    updateProduct:'/bd/product/updateProduct',//修改商品
    updateProductarrivalDate:'/bd/product/updateProductarrivalDate',
    addProduct:'/bd/product/addProduct',
    deleteProduct:'/bd/product/deleteProduct',
    getProduct:'/bd/product/getProduct',
    getProductForPackage:'/bd/product/getProductForPackage',
    getProductForContract:'/bd/product/getProductForContract',
    getProductForPro:'/bd/product/getProductForPro',
    getProductForOrder:'/bd/product/getProductForOrder',
    getProductForOrders:'/bd/product/getProductForOrders',

    queryBDProductList: '/bd/product/queryBDProductList',
    selectByCode: '/bd/product/selectByCode',

    //add by tzq 20200615 同步云医购
    productToYyigouById: '/bd/product/productToYyigouById',

  },
  productPackage:{
    queryProductPackageList:'/bd/productPackage/queryProductPackageList',
    getProductPackage:'/bd/productPackage/getProductPackage',
    deleteProductPackage:'/bd/productPackage/deleteProductPackage',
    updateProductPackage:'/bd/productPackage/updateProductPackage',
    addProductPackage:'/bd/productPackage/addProductPackage',
    updateStatus:'/bd/productPackage/updateStatus',
  },
  Instrument:{
    deleteInstrument:'/bd/instrument/deleteInstrument',
    addInstrument:'/bd/instrument/addInstrument',
    getInstrument:'/bd/instrument/getInstrument',
    updateInstrument:'/bd/instrument/updateInstrument',
    updateEnable:'/bd/instrument/updateEnableStatus',
    quryInstrumentList:'/bd/instrument/queryInstrumentList',
  },
  TranSport:{
    queryTransportList:'/bd/transport/queryTransportList',
    getTransport:'/bd/transport/getTransport',
    updateTransport:'/bd/transport/updateTransport',
    addTranspTranSport:'/bd/transport/addTransport',
    deleteTransport:'/bd/transport/deleteTransport',
  },
  //获取界面按钮权限请求地址
  getMenuByCode: "/sys/menu/getUserButtonMenuByCode",

  checkSysCodeByType:"/sys/config/getSysCodeByType",  //判断是否自动生成单据号

  synchroHistory:"/ws/queryWSHistorys",//同步聊天记录接口地址
  getClientCompName:"/ws/getCompanyNameByUserId",//查询客户公司名称接口
  // 商品页面请求地址
  // queryMaterial: "/bd/material/queryMaterials", // 列表
  // queryGMaterial: "/bd/material/queryGMaterials", // 高级搜索
  // delListMaterial: "/bd/material/delMaterials", // 批量删除
  // UpAllMaterial: "/bd/material/updateEnables", // 批量启用
  // DownAllMaterial: "/bd/material/delEnables", // 批量停用
  // updateMaterial: "/bd/material/updateMaterial", // 编辑商品
  // queryMaterialById: "/bd/material/getMaterialById", // 详情
  // updateEnable: "/bd/material/updateEnable", // 修改状态
  // delMaterial: "/bd/material/delMaterial", // 删除商品
  // addMaterial: "/bd/material/addMaterial", // 新增商品
  // 商品树
  // delTree: "/bd/materialtype/delMaterialType",// 删除商品类型
  // append: "/bd/materialtype/append", // 新增下级商品类型
  // queryMaterialtypeById: "/bd/materialtype/getMaterialtypeById", // 详情
  // queryMaterialtypelist: "/bd/materialtype/queryMaterialtypelist", // 商品级联下拉
  // materialTypelist: "/bd/materialtype/queryMaterialtypes", // 商品类型列表
  // updatematerialtype: '/bd/materialtype/updatematerialtype', // 修改商品类型
  // addmaterial: '/bd/materialtype/addmaterial', // 新增一级商品类型123

  diction:{
    // 数据字典
    delListDictionary: "/sys/dictionary/delListDictionary", // 批量删除
    queryDictionary: "/sys/dictionary/queryDictionary",// 列表
    delDictionary: "/sys/dictionary/delDictionary", // 删除
    updateDictionary: "/sys/dictionary/updateDictionary",// 修改
    addDictionary: "/sys/dictionary/addDictionary", // 新增
    queryDictionaryById: "/sys/dictionary/queryDictionaryById", // 详情
  },
  // 登陆日志
  delListLoginLog: "/sys/loginlog/delListLoginLog",// 删除
  querySysLoginLog: "/sys/loginlog/querySysLoginLogs",// 列表
  // 操作日志
  delListOperateLog: "/sys/operatelog/delListOperateLog", //  删除
  querySysOperateLog: "/sys/operatelog/querySysOperateLog",// 列表
  // 重置密码
  resetPassword: "/bd/employee/updateResetPassword",

  // 收款单  应收单
  // fin : {
  //   // 收款单
  //   queryFinPayment:"/fin/finpay/queryFinPayment", // 列表
  //   delFinPayment:"/fin/finpay/delFinPayment", // 删除
  //   updateFinPayment:"/fin/finpay/updateFinPayment",// 修改
  //   getFinPayment:"/fin/finpay/getFinPayment", // 详情
  //   addFinPayment:'/fin/finpay/addFinPayment',
  //   //应收单
  //   queryFinreceivables: "/fin/finreceivable/queryFinreceivables",// 列表
  //   getAdvancemoney:"/fin/finreceivable/getAdvancemoney", // 获取金额
  //   updateFinStatus:"/fin/finreceivable/updateFinStatus",// 修改
  //   getFinReceivable:"/fin/finreceivable/getFinReceivable", // 详情
  //   updateFinReceivable:"/fin/finreceivable/updateFinReceivable", // 修改
  //   addFinReceivable:"/fin/finreceivable/addFinReceivable",// 新增

  // },

  /*-------------------------------------------------bd客户模块----------------------------------------------------*/
  //客户
  queryCustomerList:"/bd/customer/queryCustomerList",  //分页
  queryCustomerLists:"/bd/customer/queryCustomerLists",  //分页
  addDistributor:"/bd/customer/addCustomer",            //新增
  updateDistributor:"/bd/customer/updateCustomer",     //更新
  getCustomerById:"/bd/customer/getCustomerById",      //详情
  initPassword:"/sys/user/initPassword",                 //重置密码
  getCustomerTypeAndCompanyList:"/bd/customer/getCustomerTypeAndCompanyList", //分类级联
  getDepartmentAndEmployee:"/bd/customer/getDepartmentAndEmployee",   //部门和人员
  queryDepartmentByCompany:"/bd/department/queryDepartmentByCompany",  //公司切换查询部门
  queryCommercePeopleBySalesDepartment:"/bd/department/queryCommercePeopleBySalesDepartment",  //商务部门切换
  batchDelCustomerById:"/bd/customer/batchDelCustomerById",  //客户批量删除
  CheckBeforeSubmitCustomer:"/bd/customer/CheckBeforeSubmitCustomer",   //客户提交前审核
  submitCustomerById:"/bd/customer/submitCustomerById",   //客户提交
  getCustomerK3Code:"/bd/customer/getCustomerK3Code",     //获取客户K3Code
  updateCustomerK3Code:"/bd/customer/updateCustomerK3Code", //批量修改K3Code

  //add by tzq 同步云医购
  customerToYyigouById:"/bd/customer/customerToYyigouById",

  //客户变更
  addCustomerChange:"/bd/customerChange/addCustomerChange",            //客户变更新增
  getCustomerChangeById:"/bd/customerChange/getCustomerChangeById",   //客户变更详情
  delCustomerChangeById:"/bd/customerChange/delCustomerChangeById",   //客户变更删除
  submitCustomerChangeById:"/bd/customerChange/submitCustomerChangeById", //客户变更提交

  //客户分类
  queryCustomerCategoryTree:"/bd/customerCategory/queryCustomerCategoryTree",  //客户分类查询
  addCustomerCategory:"/bd/customerCategory/addCustomerCategory",                //新增客户分类
  getCustomerCategoryById:"/bd/customerCategory/getCustomerCategoryById",       //客户分类详情
  updateCustomerCategory:"/bd/customerCategory/updateCustomerCategory",         //客户分类修改
  delCustomerCategoryById:"/bd/customerCategory/delCustomerCategoryById",       //客户分类逻辑删除
  //医院
  queryHospitalList:"/bd/hospital/queryHospitalList", //医院列表
  addHospital:"/bd/hospital/addHospital",  //医院新增
  updateHospital:"/bd/hospital/updateHospital",  //医院修改
  getHospitalType:"/bd/hospital/getHospitalType",  //医院级别
  getHospitalById:"/bd/hospital/getHospitalById",  //医院详情
  delHospitalById:"/bd/hospital/delHospitalById",  //医院删除
  enabledHospitalById:"/bd/hospital/enabledHospitalById", //医院启用停用
  /*--------------------------------------------------bd回收商模块---------------------------------------------------*/

  /**
   * 收款单
   */
  queryPaymentOrderList:"/pay/paymentorder/queryPaymentOrderList",  //收款单查询

  queryPaymentOrderListByComp:"/pay/paymentorder/queryPaymentOrderListByComp",  //企业端收款单查询

  queryCollectionOrderList:"/pay/collectionOrder/queryCollectionOrderList",  //K3收款查询
  customerPayStep:"/pay/collectionOrder/customerPayStep",  //K3同步
  getCollectionOrderById:"/pay/collectionOrder/getCollectionOrderById", //收款单详情
  getCollectionById:"/pay/collectionOrder/getCollectionById", //收款单详情
  addPayReceivebillHx:"/pay/payreceivebillhx/addPayReceivebillHx", //付款单核销新增
  queryHasAuditNoallpayOrder:"/pay/payreceivebillhx/queryHasAuditNoallpayOrder", //付款单核销新增
  getPayReceivebillHxById:"/pay/payreceivebillhx/getPayReceivebillHxById",  //核销详情
  updatePayReceivebillHx:"/pay/payreceivebillhx/updatePayReceivebillHx",  //核销修改
  delPayReceivebillHxById:"/pay/payreceivebillhx/delPayReceivebillHxById",  //核销删除
  submitPayReceivebillHxById:"/pay/payreceivebillhx/submitPayReceivebillHxById",  //核销提交
  getNotAuditReceivebillHxList:"/pay/payreceivebillhx/getNotAuditReceivebillHxList",  //获取客户下未审核核销单的订单
  queryNoReceivebillHxOrder:"/od/order/queryNoReceivebillHxOrder",   //尚未核销订单总金额

  getCompanyAndBankList:"/pay/paymentorder/getCompanyAndBankList",  //获取销售公司
  queryHasAuditOrder:"/od/order/queryHasAuditOrder",  //获取已选择的订单
  addPaymentOrder:"/pay/paymentorder/addPaymentOrder", //新增收款单
  updatePaymentOrder:"/pay/paymentorder/updatePaymentOrder", //修改收款单
  getPaymentOrderById:"/pay/paymentorder/getPaymentOrderById",  //收款单详情
  delPaymentOrderById:"/pay/paymentorder/delPaymentOrderById",  //收款单删除
  submitPaymentOrderById:"/pay/paymentorder/submitPaymentOrderById",  //收款单提交
  queryHasAuditNoallpayOrder:"/od/order/queryHasAuditNoallpayOrder",  //获取已审核未支付完的订单

  /**
   * 往来对账
   */
  getCustomerByCompanyId:"/bd/customer/getCustomerByCompanyId",    //根据公司id获取客户
  queryAccountList:"/pay/account/queryAccountList",  //对账列表
  addAccount:"/pay/account/addAccount",          //新增对账
  updateAccount:"/pay/account/updateAccount",   //修改对账
  getAccountById:"/pay/account/getAccountById", //对账详请
  delAccountById:"/pay/account/delAccountById", //对账删除
  submitAccountById:"/pay/account/submitAccountById", //对账提交
  receiveAccountById:"/pay/account/receiveAccountById", //对账收函
  getNotAuditAccountList:"/pay/account/getNotAuditAccountList",  //获取以选择订单

  /**
   * 报表
   */
  queryCustomerInformation:"/report/customerinformation/queryCustomerInformation",  //客户信息查询
  queryOrderDetail:"/report/reports/queryOrderDetail",
  queryTxOrderDetail:"/report/reports/queryTxOrderDetail",
  queryTxOrderHZ:"/report/reports/queryTxOrderHZ",
  queryAreaOrder:"/report/reports/queryAreaOrder",
  queryDepartmentDaySales:"/report/reports/queryDepartmentDaySales",
  querySalesGoods:"/report/reports/querySalesGoods",
  querySalesCustomer:"/report/reports/querySalesCustomer",
  queryMonthSales:"/report/reports/queryMonthSales",
  queryDaySales:"/report/reports/queryDaySales",
  queryCustomerBuyPlan:"/report/reports/queryCustomerBuyPlan",
  queryStatisticalTableVOs:"/report/reports/queryStatisticalTableVOs",
  /**
   * 系统设置Begin  By kb
   */
  //用户设置的请求
  user: {
    //列表下的请求
    qrUsers: "/sys/user/querySysUsers",//查找用户列表
    delUsers: "/sys/user/deleteSysUsers",  //批量删除用户
    delUser: "/sys/user/deleteSysUser",  //删除用户
    upUserEnabled: "/sys/user/updateSysUserEnabled",  //停用或者启用 用户
    //详情下的请求
    restUserPwd: "/sys/user/initPassword",//查询所有角色列表
    //编辑/新增下的请求
    qrRoles: "/sys/role/queryExcludeSysRole",//查询所有角色列表
    qrCurRoles: "/sys/userrole/querySysUserRoles",//查询当前角色列表
    qrUser: "/sys/user/getSysUserById",//查询用户信息
    //绑定菜单下的请求
    qrMenuTree:"/sys/menu/querySysMenuTree",//查询菜单树
    editUserMenu:"/sys/usermenu/editSysUserMenu",//编辑用户绑定菜单
    addUserMenu:"/sys/usermenu/addSysUserMenu",//新增用户绑定菜单
    qrUserMenu:"/sys/usermenu/getUserMenuByUserId",//
  },
  //菜单设置的请求
  menu: {
    queryMenus4Add: "/sys/menu/queryMenus4Add",//查询界面下拉数据
    addMenu:"/sys/menu/addSysMenu", //新增菜单
    upMenu:"/sys/menu/updateSysMenu",//修改菜单
    qrMenu:"/sys/menu/getSysMenuById",//查询菜单数据
    delMenu:"/sys/menu/delSysMenuById",//删除菜单
    getMaxcode:"/sys/menu/getSysMenuMaxCodeById",//查询菜单数据

  },
  //角色设置
  role: {}

  /**
   * 系统设置End   By kb
   */

}





// WEBPACK FOOTER //
// ./src/commonJs/reqconf.js